import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import axios from "axios";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import ListAltIcon from "@mui/icons-material/ListAlt";
import "./Dashboard.css";

const Dashboard = () => {
  const { user } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState({
    walletBalance: 0,
    orders: {
      total: 0,
      completedCount: 0,
      successAmount: 0
    },
    transactions: {
      total: 0,
      successfulCount: 0,
      successAmount: 0
    }
  });
  const [loading, setLoading] = useState(false);

  const getDashboardData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        "https://api.zorotopup.com/api/v1/user/dashboard",
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (res.data.message === "Dashboard data retrieved successfully") {
        setDashboardData(res.data.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (user !== null) {
      getDashboardData();
    }
  }, [user]);

  return (
    <Layout>
      <div className="user-dashboard">
        <h4>Welcome Back! User</h4>
        <div className="shadow dash-card" onClick={() => navigate("/wallet")}>
          <div className="count">
            <span>Wallet Balance</span>
            <h1 className="m-0">
              <b>₹{dashboardData?.walletBalance || 0}</b>
            </h1>
          </div>
        </div>

        <div className="shadow dash-card" onClick={() => navigate("/orders")}>
          <div className="count">
            <span>Total Orders</span>
            <h1 className="m-0">
              <b>₹{dashboardData?.orders?.successAmount || 0}</b>
            </h1>
          </div>
        </div>

        <div className="shadow dash-card" onClick={() => navigate("/orders")}>
          <div className="count">
            <span>Number of Orders</span>
            <h1 className="m-0">
              <b>{dashboardData?.orders?.completedCount || 0}</b>
            </h1>
          </div>
        </div>
        <div className="shadow dash-card" onClick={() => navigate("/payments")}>
          <div className="count">
            <span>Total Transactions</span>
            <h1 className="m-0">
              <b>₹{dashboardData?.transactions?.successAmount || 0}</b>
            </h1>
          </div>
        </div>
        <div className="shadow dash-card" onClick={() => navigate("/payments")}>
          <div className="count">
            <span>Number of Transactions</span>
            <h1 className="m-0">
              <b>₹{dashboardData.transactions?.successfulCount || 0}</b>
            </h1>
          </div>
        </div>
        {/* <div className="shadow dash-card" onClick={() => navigate("/query")}>
          <div className="count">
            <span>Queries</span>
            <h1 className="m-0">--</h1>
          </div>
        </div> */}
        <h5>Quick Actions</h5>
        <div className="quickbuttons">
          <button onClick={() => navigate("/wallet")}>
            <AccountBalanceWalletIcon className="icon" />
            Add Money
          </button>
          <button onClick={() => navigate("/")}>
            <SportsEsportsIcon className="icon" />
            Recharge Games
          </button>
          <button onClick={() => navigate("/orders")}>
            <ListAltIcon className="icon" />
            View Orders
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
